import React from 'react'

// Helper Functions
import { formatUrl } from '../../helperFunctions'

export const TAGS = ['all', 'federal', 'state', 'local']

// All project titles
export const PROJECT_TITLES = {
  calTran: 'California Department of Transportation City of Fontana',
  miccFort: 'MICC Fort Irwin',

  government: {
    la: 'LA county Sheriff Video Wall System with Video Wall',
    metrolink: 'Metrolink Videwall Installation',
    starbase: 'StarBase AV Installation',
    micc: 'Upgrade Audio Visual & VTC System',
    miramar: 'Miramar Recording Studio AV Installation',
    veteran: 'Veteran Affairs Southern Nevada Healthcare System',
  },

  education: {
    palomar: 'Palomar College Audiovisual Equipment Installation',
    allied: 'Allied Health Building',
    santa: 'Santa Monica Community College'
  },

  private: {
    bakemark: 'Bakemark',
  },

  worship: {
    kwang: 'Kwang Myung AV and Lighting Installation',
    promised: 'The Promised Church AV Installation',
    sae: 'Sae Hyun Church AV Installation',
    choong: 'Choong Hyun Church AV Installation',
    young: 'Young Nak'
  }

}

export const OVERVIEW = [
  {
    category: 'government',
    title: 'Government',
    bg: 'bg-page-banner',
    para: <React.Fragment>
      <p>Government facilities require a high level of technology to keep up with the efficiency, productivity and safety needs. EIDIM’s solution is based on your needs, your budget and your existing technology. They include a variety of solutions for hearings, meeting, control and command system, presentations, conferences and security monitoring that keep employees and community members engaged.</p>
      <p>EIDIM has the experience to create customized systems that meet a variety of needs for government; conference rooms, meeting rooms congress, council, city hall, security administration, library and services department.</p>
    </React.Fragment>,
    tags: TAGS,
    work: [
      {
        tag: [TAGS[0], TAGS[2]],
        title: PROJECT_TITLES.government.la,
        bg: 'bg-gov-la-1',
        link: formatUrl(PROJECT_TITLES.government.la),
      },

      {
        tag: [TAGS[0], TAGS[2]],
        title: PROJECT_TITLES.government.metrolink,
        bg: 'bg-gov-metrolink-1',
        link: formatUrl(PROJECT_TITLES.government.metrolink),
      },

      {
        tag: [TAGS[0], TAGS[2]],
        title: PROJECT_TITLES.government.starbase,
        bg: 'bg-gov-starbase-1',
        link: formatUrl(PROJECT_TITLES.government.starbase),
      },

      {
        tag: [TAGS[0], TAGS[1]],
        title: PROJECT_TITLES.government.micc,
        bg: 'bg-gov-starbase-1',
        link: formatUrl(PROJECT_TITLES.government.micc),
      },

      {
        tag: [TAGS[0], TAGS[1]],
        title: PROJECT_TITLES.government.miramar,
        bg: 'bg-gov-federal-miramar-1',
        link: formatUrl(PROJECT_TITLES.government.miramar),
      },

      {
        tag: [TAGS[0], TAGS[1]],
        title: PROJECT_TITLES.government.veteran,
        bg: 'bg-gov-federal-veteran-1',
        link: formatUrl(PROJECT_TITLES.government.veteran),
      },
    ]
  },

  {
    category: 'education',
    title: 'Education',
    bg: 'bg-page-banner',
    tags: [TAGS[0]],
    para: <React.Fragment>
      <p>Educational institutions must equip with the proven technology and service to support their students' needs for learning. EIDIM provides the faculty and students with comprehensive audiovisual tools and environments that encourage learning and collaboration. </p>
      <p>We work closely with our customers to customize a solution that meets their specific needs of educator and to ensure that everything is integrated properly.</p>
    </React.Fragment>,
    work: [
      {
        tag: [TAGS[0]],
        title: PROJECT_TITLES.education.palomar,
        bg: 'bg-edu-palomar-1',
        link: formatUrl(PROJECT_TITLES.education.palomar),
      },

      {
        tag: [TAGS[0]],
        title: PROJECT_TITLES.education.allied,
        bg: 'bg-edu-allied-1',
        link: formatUrl(PROJECT_TITLES.education.allied),
      },

      {
        tag: [TAGS[0]],
        title: PROJECT_TITLES.education.santa,
        bg: 'bg-edu-santa-1',
        link: formatUrl(PROJECT_TITLES.education.santa),
      },
    ]
  },

  {
    category: 'house-of-worship',
    title: 'House of Worship',
    bg: 'bg-page-banner',
    tags: [TAGS[0]],
    para: <React.Fragment>
      <p>We have served auditorium and worship Halls for over 20 years. EIDIM has both the ability and the experiences to provide a comprehensive service for our customers, which enhance lectures, seminars, music concerts, religious services, movie theatres.</p>
      <p>With our consultants help select the best fit audiovisual system to meet the end-user’s specific needs.</p>
    </React.Fragment>,
    work: [
      {
        tag: [TAGS[0]],
        title: PROJECT_TITLES.worship.kwang,
        bg: 'bg-worship-kwang-1',
        link: formatUrl(PROJECT_TITLES.worship.kwang),
      },

      {
        tag: [TAGS[0]],
        title: PROJECT_TITLES.worship.promised,
        bg: 'bg-worship-promised-1',
        link: formatUrl(PROJECT_TITLES.worship.promised),
      },

      {
        tag: [TAGS[0]],
        title: PROJECT_TITLES.worship.sae,
        bg: 'bg-worship-sae-1',
        link: formatUrl(PROJECT_TITLES.worship.sae),
      },

      {
        tag: [TAGS[0]],
        title: PROJECT_TITLES.worship.choong,
        bg: 'bg-worship-choong-1',
        link: formatUrl(PROJECT_TITLES.worship.choong),
      },

      {
        tag: [TAGS[0]],
        title: PROJECT_TITLES.worship.young,
        bg: 'bg-worship-young-1',
        link: formatUrl(PROJECT_TITLES.worship.young),
      },
    ]
  },

  {
    category: 'private-commercial',
    title: 'Private / Commercial',
    bg: 'bg-page-banner',
    tags: [TAGS[0]],
    para: <React.Fragment>
      <p>EIDIM offers audiovisual solutions that allow corporations to communicate with more efficacies. Corporations can save time and the amount of frustration from misunderstandings or inconsistent systems. EIDIM’s goal is to provide for our clients a technologically advanced system that is not only simple to use, but reliable and cost effective.</p>
      <p>Through consultation and design plans, we will strive to provide our clients with the latest technology as well as meet one’s budget. Through our experienced technicians and engineers, we can fulfill the needs of either grandiose or cost effective and relatively simple project expectations.</p>
    </React.Fragment>,
    work: [
      {
        tag: [TAGS[0]],
        title: PROJECT_TITLES.private.bakemark,
        bg: 'bg-private-bakemark-1',
        link: formatUrl(PROJECT_TITLES.private.bakemark),
      },
    ]
  }
]